module.exports = __webpack_public_path__ + "static/richard-branson-vfp-tweet-e3e4af5d53a3047cc8893dc1133d5a1c.png";